import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";

function SectionTitle({ title, subtitle, extraComponent }) {
  return (
    <Grid container style={{ padding: 10 }} spacing={1}>
      {title && (
        <Grid item xs={12}>
          <Typography variant="h4">{title}</Typography>
        </Grid>
      )}
      {subtitle && (
        <Grid item xs={12}>
          <Typography variant="h5">{subtitle}</Typography>
        </Grid>
      )}
      {extraComponent && (
        <Grid item xs={12}>
          {extraComponent}
        </Grid>
      )}
    </Grid>
  );
}

SectionTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  extraComponent: PropTypes.node,
};

export default SectionTitle;
